import React from "react";
import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const year = new Date().getFullYear();

  return (
    <footer className="ft-blue">
      <div className="ft-wrap">
        <div className="ft-top">

          {/* BRAND */}
          <section className="ft-brand">
            <div className="ft-logo">
              {webinfo.logowhite ? (
                <img src={webinfo.logowhite} alt={webinfo.name || "Brand"} />
              ) : (
                <h2 className="ft-brand-text">
                  {webinfo.name || "Promotexy"}
                </h2>
              )}
            </div>

            <p className="ft-desc">
              We build clear, fast digital experiences that convert and scale—from strategy and design to development and support.
            </p>

            <div className="ft-tags">
              <span>Clear communication</span>
              <span>Performance-first</span>
              <span>Long-term support</span>
              <span>Secure builds</span>
            </div>

            <form
              className="ft-news"
              onSubmit={(e) => {
                e.preventDefault();
                const email = e.target.email.value;
                window.location.href = `mailto:${webinfo.email}?subject=Subscribe&body=Add ${email}`;
              }}
            >
              <input
                name="email"
                type="email"
                placeholder="you@company.com"
                required
              />
              <button type="submit" className="ft-btn">
                Subscribe
              </button>
            </form>
          </section>

          {/* SERVICES */}
          <nav className="ft-col">
            <h4>Services</h4>
            <ul>
              <li><a href="/services">All services</a></li>
              <li><a href="/services/ui-ux-design">UI / UX &amp; Website Design</a></li>
              <li><a href="/services/web-development">Website &amp; App Development</a></li>
              <li><a href="/services/search-engine-optimization">SEO &amp; Search Visibility</a></li>
              <li><a href="/services/social-media-marketing">Social Media Marketing</a></li>
              <li><a href="/services/search-engine-marketing">Paid Ads &amp; Lead Generation</a></li>
              <li><a href="/services/local-business-growth">Local Business Growth</a></li>
              <li><a href="/process">Process</a></li>
            </ul>
          </nav>

          {/* COMPANY */}
          <nav className="ft-col">
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/our-strategies">Insights</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="/services">Pricing</a></li>
            </ul>
          </nav>

          {/* CONTACT */}
          <section className="ft-contact">
            <h4>Contact</h4>
            <div className="ft-card">
              <div className="ft-row">
                <span className="ft-k">EMAIL</span>
                <a className="ft-v" href={`mailto:${webinfo.email}`}>
                  {webinfo.email || "contact@promotexy.com"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">PHONE</span>
                <a className="ft-v" href={`tel:${webinfo.phonecall}`}>
                  {webinfo.phone || "+91 80000 00000"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">HOURS</span>
                <span className="ft-v">
                  {webinfo.hours || "Mon–Sat · 10am–7pm IST"}
                </span>
              </div>

              <div className="ft-social">
                <a href={webinfo.linkedin || "#"}>in</a>
                <a href={webinfo.twitter || "#"}>X</a>
                <a href={webinfo.instagram || "#"}>IG</a>
              </div>
            </div>
          </section>

        </div>

        {/* BOTTOM */}
        <div className="ft-bottom">
          <p>© {year} {webinfo.name || "Promotexy"}. All rights reserved.</p>
          <div className="ft-legal">
            <a href="/terms-and-conditions">Terms</a>
            <a href="/privacy-policy">Privacy</a>
            <a href="/refund-policy">Refund Policy</a>
            <a href="/shipping-policy">Shipping Policy</a>
            <a href="/disclaimer">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
